module.exports = __webpack_public_path__ + "0aa3ee94f7d51b9e1f9371469d242e58.png";